module.exports = __webpack_public_path__ + "img/slide2.b33e5824.jpg";